import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./EventCategories.css";
import corporateImg from "../assets/corp.jpg";
import weddingImg from "../assets/wedding.jpg";
import privateImg from "../assets/live.jpg";

const EventCategories = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const cards = [
  {
    title: "Corporate Events",
    description:
      "We plan impactful corporate events—from conferences and product launches to retreats and celebrations. Our team ensures every detail reflects your brand with precision and professionalism.",
    image: corporateImg,
    gradient: "linear-gradient(135deg, #a349a4, #2d004d);",
  },
  {
    title: "Corporate Parties",
    description:
      "Make your corporate parties unforgettable. We handle everything from venue and décor to entertainment, ensuring a seamless event that aligns with your brand and leaves a lasting impact.",
    image: weddingImg,
    gradient: "linear-gradient(135deg, #a349a4, #2d004d)",
  },
  {
    title: "Private Parties",
    description:
      "Celebrate birthdays, anniversaries, or special moments with style. From themes and lighting to music and décor, we create vibrant, personalized experiences your guests will always remember.",
    image: privateImg,
    gradient: "linear-gradient(135deg, #a349a4, #2d004d)",
  },
];


  return (
    <section className="event-section py-5">
      <div className="container">
        <div className="row justify-content-center g-4">
          {cards.map((card, idx) => (
            <div className="col-md-4" key={idx} data-aos="fade-up">
              <div
                className="event-card bg-image-hover-gradient"
               style={{
  backgroundImage: `url(${card.image})`,
  "--hover-gradient": "linear-gradient(to right, #fda9e4, #cb8eff)", // override here if needed
}}

              >
                <div className="event-card-content text-white rounded-4">
                  <div className="arrow-icon">↗</div>
                  <h5>{card.title}</h5>
                  <p>{card.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventCategories;
